import JessieOLP from './olp-jessie-min'

let OLP = JessieOLP.OLP;

OLP.functionReady("initHelpToggle", function () {
    OLP.initHelpToggle();
});

(function () {
    var cleanup = function () {
        var els = ["login-menu", "main-menu", "account-menu"];
        for (var i = els.length; i--;) {
            var id = els[i];
            var obj = OLP.obj(id);
            if (obj) {
                obj.style.display = 'inline-block';
            }
        }
    };


    OLP.docReady(function () {
        if (OLP.mobilize) {
            OLP.mobilize();
        } else {
            cleanup();
        }
    });
})();
